import { useEffect, useState } from 'react';

/**
 * Delay a fast-changing value so it does not drive a request per keystroke.
 *
 * Used on list search boxes: without it, typing "Northwind" fires nine queries
 * and the answers can arrive out of order, so the list briefly shows results for
 * "Northwi".
 *
 * @template T
 * @param {T} value
 * @param {number} [delay=300] milliseconds of quiet before the value settles
 * @returns {T}
 */
export function useDebounce(value, delay = 300) {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return settled;
}
